import { h } from "preact";

export default function OptionValuePrice({
  selectedVariant,
  variant,
  className = "",
}) {
  if (!selectedVariant?.priceV2?.amount || !variant?.priceV2?.amount)
    return null;

  // if (selectedVariant.priceV2.amount === variant.priceV2.amount) return null;

  return (
    <div className={`${className} product-form__option-value-price`}>
      <span className="product-form__option-value-current-price">
        {window.formatMoney(variant.priceV2.amount)}
      </span>
      {variant.compareAtPriceV2?.amount &&
        parseFloat(variant.compareAtPriceV2?.amount) >
          parseFloat(variant.priceV2.amount) && (
          <del className="product-form__option-value-compare-at-price">
            {window.formatMoney(variant.compareAtPriceV2.amount)}
          </del>
        )}
    </div>
  );
}
